// Generated by purs version 0.15.16
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as React from "../React/index.js";
var toElement = /* #__PURE__ */ React.toElement(React.isReactElementArray);
var monoidEffect = /* #__PURE__ */ Effect.monoidEffect(Data_Monoid.monoidUnit);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidFn(monoidEffect));
var component = /* #__PURE__ */ React.component();
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Concur_Core_Types.applyWidget);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(monoidEffect);
var createLeafElement = /* #__PURE__ */ React.createLeafElement();
var render = function (st) {
    return toElement(st.view);
};
var mkComponentState = function (v) {
    return {
        view: v
    };
};
var affAction = function (aff) {
    var handler = function (v) {
        return function (v1) {
            if (v1 instanceof Data_Either.Right) {
                return v(new Concur_Core_Types.Completed(v1.value0));
            };
            if (v1 instanceof Data_Either.Left) {
                return Effect_Console.log("error calling aff");
            };
            throw new Error("Failed pattern match at Concur.React (line 65, column 3 - line 65, column 42): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
    return Concur_Core_Types.mkWidget(function (cb) {
        return function __do() {
            var fiber = Effect_Aff.runAff(handler(cb))(aff)();
            return Effect_Aff.runAff_(mempty)(Effect_Aff.killFiber(Effect_Exception.error("cancelling aff"))(fiber));
        };
    });
};
var toReactClassWithMount = function (componentName) {
    return function (initialView) {
        return function (onMount) {
            return function (widgetBuilder) {
                return component(componentName)(function ($$this) {
                    return function __do() {
                        var props = React.getProps($$this)();
                        var widget = applySecond(affAction(Effect_Aff.delay(0.0)))(widgetBuilder(props));
                        Concur_Core_Types.runWidget(widget)(function (res) {
                            if (res instanceof Concur_Core_Types.View) {
                                return React.writeState($$this)(mkComponentState(res.value0));
                            };
                            return Effect_Console.log("Application exited");
                        })();
                        return {
                            state: mkComponentState(initialView),
                            render: map(render)(React.getState($$this)),
                            componentDidMount: onMount
                        };
                    };
                });
            };
        };
    };
};
var toReactClass = function (componentName) {
    return function (initialView) {
        return function (widgetBuilder) {
            return toReactClassWithMount(componentName)(initialView)(mempty1)(widgetBuilder);
        };
    };
};
var toReactElement = function (componentName) {
    return function (initialView) {
        return function (widget) {
            var reactClass = toReactClass(componentName)(initialView)(Data_Function["const"](widget));
            return createLeafElement(reactClass)({});
        };
    };
};
export {
    mkComponentState,
    render,
    toReactClass,
    toReactClassWithMount,
    toReactElement,
    affAction
};
//# sourceMappingURL=index.js.map
